import { render } from "./bank_account_individual_verification.html?vue&type=template&id=2406bf43&external"
import script from "./bank_account_individual_verification.js?vue&type=script&lang=js&external"
export * from "./bank_account_individual_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__